import React, { useState, useEffect } from 'react'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import { format } from 'fecha';
// import ReactTooltip from 'react-tooltip';
import TextField from "@material-ui/core/TextField";
// import Input from "@material-ui/core/Input";
// import IViewPostulante from '../../view-interfaces/IViewPostulante';
import IViewDatosPersonales from '../../view-interfaces/IViewDatosPersonales';
import { useHistory, useLocation } from 'react-router-dom';
import { Alert } from '@material-ui/lab';
import { ObtenerTokenEmailLogic, ObtenerTokenLogic, useStyles } from '../../view-model/Inicio/InicioEstudiante.logic';
import d1 from '../../../assets/dist/svg/main.svg';
import { GoogleLogin, GoogleLogout, useGoogleLogout, UseGoogleLogoutProps } from 'react-google-login';
import IViewLoginGoogle from '../../view-interfaces/IViewLoginGoogle';
import { RetornaDominio } from '../../view-model/Funciones/Global';
// import GoogleLogoutButton from '../../view-google/GoogleLogoutButton';
// import GoogleBtn from '../../view-google/GoogleLogoutButton';
import NewHeaderInicio from '../../util/NewHeaderInicio';
import { Button, Grid, InputLabel } from '@material-ui/core'
import HeaderInicio from '../../util/headerInicio';
//import { Button, Dialog, DialogActions, Grid, DialogContent, DialogTitle, Checkbox, InputLabel, Paper, PaperProps } from '@material-ui/core'
// import LoginModal from '../../view-model/Modals/LoginModal'
const { formatterRut, cleanRut } = require('chilean-formatter')
type Props = { postulante: IViewDatosPersonales[] }
const Preguntas: React.FC<Props> = ({ postulante }) => {

    const history = useHistory();
    const location = useLocation();

    let fecha = format(new Date(), 'YYYY-MM-DD');
    const lista: Array<IViewDatosPersonales> = [];
    const [personaParams, setPersonaParams] = useState(lista);
    const [fechaNacimiento, setFechaNacimiento] = useState(fecha);
    const [mail, setMail] = useState('');
    const [pasoCorreo, setPasoCorreo] = useState(false);
    const [intentosFecha, setIntentosFecha] = useState(0);
    const [mensajeFecha, setMensajeFecha] = useState('Fecha errónea');
    const [intentosCorreo, setIntentosCorreo] = useState(0);
    const [mensajeCorreo, setMensajeCorreo] = useState('Correo erróneo');
    const [paso, setPaso] = useState(false);
    const [existeFechaNacimiento, setExisteFechaNacimiento] = useState(false);
    const [existeCorreoPersonal, setExisteCorreoPersonal] = useState(false);
    const [isGoogleUDD, setIsGoogleUDD] = useState(false);
    const listGoogle: Array<IViewLoginGoogle> = [];
    const [listGooglePostulante, setListGooglePostulante] = useState(listGoogle || null);
    const [loginManual, setLoginManual] = useState(true);
    const [esValidoElmail, setEsValidoElMail] = useState(0);
    const [mensajeGoogle, setMensajeGoogle] = useState('');
    const [dominioUDD, setDominioUDD] = useState(0);
    const [error, setError] = useState(false);
    const [mensajeError, setmensajeError] = useState('')
    //const [desdeCero, setDesdeCero] = useState(false);
    const [errorLoginGoogle, setErrorLoginGoogle] = useState(false);
    const [ErrorVeces, setErrorVeces] = useState(false);
    const [mensajeErrorVeces, setMensajeErrorVeces] = useState('');
    const [existeCorreoUDD, setExisteCorreoUDD] = useState(false);
    const [correoUDD, setCorreoUDD] = useState('');
    const [rutPostulante, setRutPostulante] = useState("");
    const handleParamssadasd = () => {
        //=> debo convertir la data para que sea reconocible
        if (personaParams.length === 0) {
            let data = JSON.stringify(location.state);
            let pr = JSON.parse(data);
            let _persona: Array<IViewDatosPersonales> = [];
            if (pr.persona[0] !== null || pr.persona[0] !== undefined) {
                _persona.push({
                    idPersona: pr.persona[0].idPersona,
                    run: pr.persona[0].run,
                    dv: pr.persona[0].dv,
                    pasaporte: pr.persona[0].pasaporte,
                    nombres: pr.persona[0].nombres.trim(),
                    primerApellido: pr.persona[0].primerApellido.trim(),
                    segundoApellido: pr.persona[0].segundoApellido.trim(),
                    fechaNacimiento: pr.persona[0].fechaNacimiento,
                    esMenorEdad: pr.persona[0].esMenorEdad,
                    codigoComuna: pr.persona[0].codigoComuna,
                    nombreComuna: pr.persona[0].nombreComuna.trim(),
                    direccion: pr.persona[0].direccion.trim(),
                    telefono: pr.persona[0].telefono,
                    email: pr.persona[0].email.trim(),
                    emailUDD: pr.persona[0].emailUDD.trim(),
                    codSexo: pr.persona[0].codSexo,
                    sexo: pr.persona[0].sexo.trim(),
                    idPais: pr.persona[0].idPais,
                    pais: pr.persona[0].pais.trim(),
                    idNacionalidad: pr.persona[0].idNacionalidad,
                    nacionalidad: pr.persona[0].nacionalidad.trim(),
                    runFormato: pr.persona[0].runFormato,
                    nombreCompleto: pr.persona[0].nombreCompleto.trim()
                });

                setPersonaParams(_persona);
                /* console.log('_postulante', _postulante); */

                //Como no puedo usar la lista en el render algo asi
                //{postulanteParams[0].fechaNacimiento.length > 5 && postulanteParams[0].fechaNacimiento.trim() !== '1900-01-01' ? 
                //debo sacar la parametria antes.
                if (_persona[0].fechaNacimiento.trim() !== '1900-01-01' && _persona[0].fechaNacimiento.length > 5) {
                    setExisteFechaNacimiento(true);
                }
                else {
                    setPasoCorreo(true);
                }

                if (_persona[0].email.length > 5) {
                    setExisteCorreoPersonal(true);
                }

                if (_persona[0].emailUDD.trim().length > 5) {
                    setCorreoUDD(_persona[0].emailUDD.trim());
                    //setExisteCorreoUDD(true);
                }
                else {
                    setLoginManual(true);
                }
                let dominio: string = "";

                if (_persona[0].emailUDD !== null) {
                    if (_persona[0].emailUDD.trim().length > 0) {
                        let arr = RetornaDominio(_persona[0].emailUDD.toString());
                        dominio = "@" + arr?.[2] + "." + arr?.[3]
                        if (dominio === "@udd.cl") {
                            setDominioUDD(1);
                            setIsGoogleUDD(true);
                        } else {
                            setDominioUDD(2);
                            setIsGoogleUDD(false);
                        }
                    }
                    else {
                        setError(true);
                        setmensajeError('No posee correo UDD')
                    }
                } else {
                    setError(true);
                    setmensajeError('No posee correo UDD')
                }

            }
        }
    }
    const handleParams = () => {
        let data = JSON.stringify(location.state);
        let pr = JSON.parse(data);
        setRutPostulante(pr.rut)
    }

    //==> Si esta montado puedo extraer la data que se mando via inicio postulante
    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });
        } else {
            handleParams();
        }
    }, [])

    const classes = useStyles();

    const validarPorFechaNacimiento = () => {
        ObtenerTokenLogic(SelObtenerToken, rutPostulante, new Date(fechaNacimiento))
    }
    const validarPorCorreo = () => {
        ObtenerTokenEmailLogic(SelObtenerTokenEmail, rutPostulante, mail)
    }
    const SelObtenerToken = (error: Boolean, err: string, data: any) => {
        try {
            console.log(error, data)
            if (error === false && data.length > 0 && data != "") {
                setPaso(true)
                history.push({
                    pathname: "/carreras",
                    state: {
                        rut: cleanRut(rutPostulante, false),
                        nombreAlumno: "",
                        headers: {
                            token: data,
                            rut: rutPostulante,
                            codNegocio: 1
                        }
                    }
                });
            } else {
                setIntentosFecha(intentosFecha + 1)
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    const SelObtenerTokenEmail = (error: Boolean, err: string, data: any) => {
        try {
            console.log(error, data)
            if (error === false && data.length > 0 && data != "") {
                setPaso(true)
                history.push({
                    pathname: "/carreras",
                    state: {
                        rut: cleanRut(rutPostulante, false),
                        nombreAlumno: "",
                        headers: {
                            token: data,
                            rut: rutPostulante,
                            codNegocio: 1
                        }
                    }
                });
            } else {
                setIntentosCorreo(intentosCorreo + 1)
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    return (
        <>
            <HeaderInicio mostrarCallCenter={true} />
            <div className="site-main__container">

                <div className={classes.rootPanelPreguntas}>
                    <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                        <Grid justifyContent="center" alignItems="stretch">
                            <Grid spacing={3}>

                                <Grid spacing={0} className={classes.panelPreguntas}>
                                    <InputLabel style={{ fontSize: 25 }}>Iniciar Sesión</InputLabel>
                                </Grid>
                                <Grid spacing={0} className={classes.panelPreguntas}>
                                    {
                                        intentosFecha < 3 ?
                                            <>
                                                <div className="row">
                                                    <div>
                                                        <p style={{ fontSize: 15, marginTop: -10 }} className="site-main__description">¿ Cuál es la fecha de nacimiento del postulante ?</p>
                                                        <div className="">
                                                            <TextField
                                                                type="date"
                                                                value={fechaNacimiento}
                                                                defaultValue={new Date()}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                onChange={(e) => {
                                                                    if (e.target.value.toString().length < 11) {
                                                                        setFechaNacimiento(e.target.value)
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <Grid spacing={0} className={classes.panelPreguntas}>
                                                    <>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            disabled={(3 - intentosFecha) < 1 ? true : paso}
                                                            onClick={() => { validarPorFechaNacimiento() }}
                                                            disableElevation>
                                                            {/* Validar */}
                                                            Continuar
                                                        </Button>
                                                    </>
                                                </Grid>
                                            </>
                                            :
                                            <>
                                                <div className="row">
                                                    <div>
                                                        <p style={{ fontSize: 15, marginTop: -10 }} className="site-main__description">¿ Cuál es el correo electrónico personal del postulante ?</p>
                                                        <div className="">
                                                            <input
                                                                disabled={(3 - intentosCorreo) < 1 ? true : false}
                                                                style={{ width: '20.5rem', display: 'inline', textAlign: 'center', border: '1px solid' }}
                                                                type="email"
                                                                className="form-control js-will-validate"
                                                                id="exampleInputEmail1"
                                                                value={mail}
                                                                placeholder={''}
                                                                onChange={(e) => setMail(e.target.value)}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <Grid spacing={0} className={classes.panelPreguntas}>
                                                    <>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            disabled={(3 - intentosCorreo) < 1 ? true : paso}
                                                            onClick={() => { validarPorCorreo() }}
                                                            disableElevation>
                                                            {/* Validar */}
                                                            Continuar
                                                        </Button>
                                                    </>
                                                </Grid>
                                            </>
                                    }

                                    {
                                        intentosFecha > 0 && paso === false && (3 - intentosFecha) > 0 ?
                                            <Alert style={{ width: '27rem', placeSelf: 'center' }} variant="outlined" severity="warning">{mensajeFecha + " - Intentos restantes : " + ((3 - intentosFecha) < 0 ? 0 : (3 - intentosFecha))}</Alert>
                                            : ''
                                    }
                                    {
                                        intentosCorreo > 0 && paso === false && (3 - intentosCorreo) > 0 ?
                                            <Alert style={{ width: '27rem', placeSelf: 'center' }} variant="outlined" severity="warning">{mensajeCorreo + " - Intentos restantes : " + ((3 - intentosCorreo) < 0 ? 0 : (3 - intentosCorreo))}</Alert>
                                            : ''
                                    }
                                    {
                                        (3 - intentosCorreo) < 1 ?
                                            <div style={{ placeSelf: 'center' }}>
                                                <Alert severity="error" variant="outlined">
                                                    <div style={{ fontSize: 13, textAlign: 'left', marginTop: '-17px' }}>
                                                        <br></br>
                                                        Comunícate con la Universidad al <strong> {'800 200 125'}</strong>
                                                    </div>
                                                </Alert>
                                                <br />
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => {
                                                        history.push({
                                                            pathname: "/Inicio"
                                                        });
                                                    }}
                                                    disableElevation>
                                                    Volver al Inicio
                                                </Button>
                                            </div>
                                            :
                                            ""
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div >
        </>
    );
}

export default Preguntas;
